import { useEffect } from 'react';
//contexts
import { useGlobalContext } from '../../contexts';
//apollo
import client from '../../src/utils/apollo/client';
//queries
import {GET_POST} from '../../src/queries/posts/get-post';
import {GET_POST_SLUGS} from '../../src/queries/posts/get-posts-slugs';
//routing
import { useRouter } from 'next/router';
import {FALLBACK, handleRedirectsAndReturnData} from '../../src/utils/slug';
//externals
import {isEmpty} from 'lodash';
//components
import Layout from '../../src/components/layout';

const Post = ( { data } ) => {
	const router = useRouter();

	// If the page is not yet generated, this will be displayed
	// initially until getStaticProps() finishes running
	if ( router.isFallback ) {
		return <div>Loading...</div>;
	}

  const { context, setContext } = useGlobalContext();

  useEffect(() => {
    if (!context.isSet) {
      data.context.options.isSet = true;
      setContext(data.context.options);
    }
  }, []);

	return (
		<Layout
      logos={data?.logos?.options?.logos}
      mainMenu={data?.mainMenu?.edges}
      menuFooter={data?.menuFooter?.edges}
      seo={data?.content?.seo}
      breadcrumbs={data?.content?.seo?.breadcrumbs}
      content={data?.content}
      pt_key={process.env.POST_PT_KEY}
      templateWhite={false}
      optionsFooter={'withContact'}
      postFeaturedImage={data?.content?.featuredImage}
      postTags={data?.content?.tags}
    >
		</Layout>
	);
};

export default Post;

export async function getStaticProps( { params } ) {

	const { data, errors } = await client.query( {
		query: GET_POST(process.env.POST_PT_KEY),
		variables: {
			uri: params?.slug ?? '/',
		},
	});

  if (data?.content != null) {
    data.content.seo.breadcrumbs.unshift({text: 'Nos actualités', url: '/nos-actualites/'});
  }

	const defaultProps = {
		props: {
			data: data || {}
		},
		revalidate: 60,
	};

	return handleRedirectsAndReturnData( defaultProps, data, errors, { allowNotFound: true } );
}

export async function getStaticPaths() {
	const { data } = await client.query( {
		query: GET_POST_SLUGS
	} );

	const pathsData = [];

	data?.posts?.nodes?.map( post => {
		if ( !isEmpty( post?.slug ) ) {
			pathsData.push( {params: { slug: post?.slug }} );
		}
	} );

	return {
		paths: pathsData,
		fallback: FALLBACK
	};
}